"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const qrcode_data_pb_1 = require("../generated/qrcode_data_pb");
const common_1 = require("../utils/common");
const index_1 = require("../index");
const EmailDataMessageV1 = qrcode_data_pb_1.vereign.protobuf.qrcode_data.EmailData_V1;
const KeyDataMessageV1 = qrcode_data_pb_1.vereign.protobuf.qrcode_data.KeyData_V1;
const WrapperDataMessage = qrcode_data_pb_1.vereign.protobuf.qrcode_data.WrapperData;
const EMAIL_DATA_V1 = "EmailData_V1";
const encodeEmailData = (emailData) => {
    const emailDataMessage = EmailDataMessageV1.fromObject(emailData);
    const emailDataBuffer = EmailDataMessageV1.encode(emailDataMessage).finish();
    const wrappedData = {
        version: 1,
        className: EMAIL_DATA_V1,
        data: emailDataBuffer,
    };
    const wrappedDataMessage = WrapperDataMessage.fromObject(wrappedData);
    const wrappedDataBuffer = WrapperDataMessage.encode(wrappedDataMessage).finish();
    return (0, common_1.arrayBufferToBase64)(wrappedDataBuffer);
};
const decodeEmailData = (binary) => {
    const wrappedDataMessage = WrapperDataMessage.decode((0, common_1.ensureUint8Array)(binary));
    const wrappedData = WrapperDataMessage.toObject(wrappedDataMessage);
    if (wrappedData.className === EMAIL_DATA_V1) {
        const emailDataMessage = EmailDataMessageV1.decode((0, common_1.ensureUint8Array)(wrappedData.data));
        const messageData = EmailDataMessageV1.toObject(emailDataMessage, {
            bytes: String,
            arrays: true,
            objects: true, // populates empty objects (map fields) even if defaults=false
        });
        return messageData;
    }
    else {
        return null;
    }
};
const encodeKeyDataPair = (keyData) => {
    const keyDataMessage = KeyDataMessageV1.fromObject(keyData);
    const buffer = KeyDataMessageV1.encode(keyDataMessage).finish();
    return (0, common_1.arrayBufferToBase64)(buffer);
};
const decodeKeyDataPair = (binary) => {
    const keyDataPairMessage = KeyDataMessageV1.decode((0, common_1.ensureUint8Array)(binary));
    return KeyDataMessageV1.toObject(keyDataPairMessage, {
        bytes: String,
    });
};
const breakQrCodeData = (data, headBytesSize = 32) => {
    if (data.byteLength <= headBytesSize) {
        return {
            head: data,
            tail: null,
        };
    }
    else {
        const dataUint8Array = new Uint8Array(data);
        return {
            head: dataUint8Array.slice(0, headBytesSize).buffer,
            tail: dataUint8Array.slice(headBytesSize, dataUint8Array.length).buffer,
        };
    }
};
const assembleQrCodeData = (head, tail) => {
    return Buffer.concat([Buffer.from(head), Buffer.from(tail)]);
};
const calculateQRCodeSignature = (accountPrivateKey, qrCodeHash) => __awaiter(void 0, void 0, void 0, function* () {
    const signature = yield index_1.CryptoService.signRSA(accountPrivateKey, Buffer.from(qrCodeHash));
    return (0, common_1.arrayBufferToBase64)(signature);
});
const verifyQrCodeSignature = (publicKey, qrCodeSignature, recipientQRCodeHash) => __awaiter(void 0, void 0, void 0, function* () {
    const qrCodeSignatureAsBuffer = (0, common_1.base64ToArrayBuffer)(qrCodeSignature);
    const recipientQRCodeHashAsBuffer = Buffer.from(recipientQRCodeHash);
    const result = yield index_1.CryptoService.verifyRSASignature(publicKey, recipientQRCodeHashAsBuffer, qrCodeSignatureAsBuffer);
    return result;
});
exports.default = {
    encodeEmailData,
    decodeEmailData,
    encodeKeyDataPair,
    decodeKeyDataPair,
    breakQrCodeData,
    assembleQrCodeData,
    calculateQRCodeSignature,
    verifyQrCodeSignature,
};
